import React, { useCallback } from "react";
import { Content, ContentType, Lesson } from "../../../types";
import FullScreenWrapper from "../full-screen-wrapper/FullScreenWrapper";
import Video from "@components/program-details/selected-content/video/Video";
import Audio from "./audio/Audio";
import Slide from "./slide/Slide";
// import GoogleSlide from './google-slide/GoogleSlide';
import Form from "./form/Form";
import Pdf from "./pdf/Pdf";
import Skill from "./skill/Skill";
import Parent from "./parent/Parent";
import { useNextContent } from "../useNextContent";
import DefaultContent from "@components/program-details/selected-content/Default";
import RevealSlideView from "./revealslide/RevealSlide";
import { logger } from '../../../utils/logger';

type Props = {
  content: Content;
  lesson?: Lesson;
  lessons?: Lesson[];
  skill?: string;
};

function SelectedContent(props: Props) {
  const { content, skill } = props;
  const { hasNextContent, nextContent, selectNext } = useNextContent();

  const onNext = useCallback(() => {
    if (hasNextContent && !nextContent?.pauseHere) {
      selectNext(content);
    }
  }, [content, hasNextContent, nextContent?.pauseHere, selectNext]);

  const presentationContent = useCallback(
    (isFullScreen) => {
      if (
        content &&
        (content.data ||
          content.formData ||
          content.type === ContentType.PARENT)
      ) {
        switch (content.type) {
          case ContentType.VIDEO: {
            return (
              <Video
                data={content.data!}
                key={content.id}
                isFullScreen={isFullScreen}
                metaData={content}
                onNext={onNext}
              />
            );
          }
          case ContentType.AUDIO: {
            return <Audio data={content.data!} isFullScreen={isFullScreen} />;
          }
          case ContentType.PDF: {
            return <Pdf data={content.data!} isFullScreen={isFullScreen} />;
          }
          case ContentType.SLIDE: {
            return <Slide data={content.data!} isFullScreen={isFullScreen} />;
          }
          case ContentType.REVEALSLIDE: {
            return (
              <RevealSlideView
                data={content.data!}
                isFullScreen={isFullScreen}
              />
            );
          }
          // case ContentType.GOOGLESLIDE: {
          //   return <GoogleSlide data={content.data!} isFullScreen={isFullScreen}/>;
          // }
          case ContentType.FORM: {
            return (
              <Form
                formData={content.formData}
                isFullScreen={isFullScreen}
                id={content.id}
                name={content.name}
              />
            );
          }
          case ContentType.PARENT: {
            return <Parent isFullScreen={isFullScreen} skill={skill} />;
          }
          case ContentType.SKILL: {
            return (
              <Skill
                data={content.data!}
                isFullScreen={isFullScreen}
                description={content.description}
              />
            );
          }
          default: {
            logger.debug(`[Not supported type]: `, content.type);
          }
        }
      } else if (content) {
        return <DefaultContent isFullScreen={isFullScreen} content={content} />;
      }
    },
    [content, onNext, skill]
  );

  return <FullScreenWrapper>{presentationContent}</FullScreenWrapper>;
}

export default SelectedContent;
